import { useCallback, useEffect, useState } from "react";
import { getBranches, getPatientCurrentBranch } from "../../../api/protocol";
import { HandleApiError } from "../../../components/Notifications/APIErrorHandler";

export const useBranches = (protocolId, refreshKey) => {
    const [data, setData] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [reload, setReload] = useState(false);

    const fetchData = useCallback(() => {
        if (!protocolId) return;
        setIsLoading(true);
        setReload(false);
        getBranches(protocolId)
            .then(response => {
                setData(response.data);
                setIsLoading(false);
            })
            .catch(error => {
                HandleApiError(error);
                setData([]);
                setIsLoading(false);
            });
    }, [protocolId]);

    useEffect(() => {
        fetchData();
    }, [fetchData, reload, refreshKey]);

    return [data, isLoading, setReload];
};

export const usePatientBranch = (protocolId, numberInProtocol) => {
    const [branch, setBranch] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [reload, setReload] = useState(false);

    useEffect(() => {
        if (!protocolId || !numberInProtocol) return;
        setIsLoading(true);
        setReload(false);
        getPatientCurrentBranch(protocolId, numberInProtocol)
            .then(response => {
                setBranch(response.status === 204 ? null : response.data);
                setIsLoading(false);
            })
            .catch(() => {
                setBranch(null);
                setIsLoading(false);
            });
    }, [protocolId, numberInProtocol, reload]);

    return [branch, isLoading, setReload];
};
